import { BorderRadius } from 'apps/cdp-web-demo/app/types';
import { RadioProps } from '@cbhq/cds-web/controls/Radio';
import { Text } from '@cbhq/cds-web/typography';

import styles from './BorderRadius.module.css';

function Radio({
  testID,
  label,
  ...props
}: Omit<RadioProps<BorderRadius>, 'color'> & { label: string }) {
  return (
    <label className={`${styles['radio-wrapper']}`} htmlFor={props.id}>
      <input
        key={`${props.name}-radio`}
        type="radio"
        {...props}
        data-testid={testID}
        className="sr-only"
      />
      <span className={styles['radio-icon']}>
        <Text font="headline" className={styles['radio-icon-label']}>
          {label}
        </Text>
      </span>
    </label>
  );
}

export { Radio };
